// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"97fec03c","455":"ed83b15a","512":"a1323d3d","585":"66e34ab2","735":"66dce47e","836":"384f0062","840":"b9c1870f","857":"3797ddd4","885":"fc9c31ce","890":"7205d833","977":"86d65106"}[chunkId] + ".chunk.js";
};